export default __webpack_public_path__ + "static/media/finding-nemo.857a3537.jpg";